// components/mobile-menu.tsx
"use client";

import { useState } from "react";
import Link from "next/link";

export default function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [isFreeToolsOpen, setIsFreeToolsOpen] = useState(false); // New state for accordion

  return (
    <>
      <button
        className="md:hidden text-gray-700 dark:text-gray-300"
        aria-label="Toggle menu"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
      >
        <svg
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
          />
        </svg>
      </button>

      {isOpen && (
        <div className="md:hidden bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 absolute left-0 right-0 top-full z-50">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link
              href="#features"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
              onClick={() => setIsOpen(false)}
            >
              Features
            </Link>

            <Link
              href="#how-it-works"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
              onClick={() => setIsOpen(false)}
            >
              How It Works
            </Link>

            <Link
              href="/free-tools"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
              onClick={() => setIsOpen(false)}
            >
              Free Tools
            </Link>

            {/* Free Tools Accordion */}
            {/* <div>
              <button
                onClick={() => setIsFreeToolsOpen(!isFreeToolsOpen)}
                className="w-full flex justify-between items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
              >
                <span>Free Tools</span>
                <svg
                  className={`w-4 h-4 transition-transform duration-300 ${
                    isFreeToolsOpen ? "rotate-180" : "rotate-0"
                  }`}
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {isFreeToolsOpen && (
                <div className="ml-4 mt-1 space-y-1">
                  <Link
                    href="/video-to-audio-convertor"
                    className="block px-3 py-2 rounded-md text-base text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
                    onClick={() => setIsOpen(false)}
                  >
                    Video to Audio Convertor
                  </Link>
                  <Link
                    href="/video-to-gif-convertor"
                    className="block px-3 py-2 rounded-md text-base text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
                    onClick={() => setIsOpen(false)}
                  >
                    Video to GIF Convertor
                  </Link>
                  <Link
                    href="/mov-to-mp4-convertor"
                    className="block px-3 py-2 rounded-md text-base text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
                    onClick={() => setIsOpen(false)}
                  >
                    .mov to .mp4 Convertor
                  </Link>
                  <Link
                    href="/mp4-to-mov-convertor"
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
                  >
                    .mp4 to .mov Convertor
                  </Link>
                  <Link
                    href="/mkv-to-mp4-convertor"
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
                  >
                    .mkv to .mp4 Convertor
                  </Link>
                  <Link
                    href="/mp4-to-mp3-convertor"
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
                  >
                    .mp4 to .mp3 Convertor
                  </Link>
                  <Link
                    href="/mp4-to-wav-convertor"
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
                  >
                    .mp4 to .wav Convertor
                  </Link>
                  <Link
                    href="/mp3-to-wav-convertor"
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
                  >
                    .mp3 to .wav Convertor
                  </Link>
                </div>
              )}
            </div> */}

            <Link
              href="#pricing"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
              onClick={() => setIsOpen(false)}
            >
              Pricing
            </Link>
            <Link
              href="/blogs"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
              onClick={() => setIsOpen(false)}
            >
              Blogs
            </Link>

            <div className="pt-4 border-t border-gray-200 dark:border-gray-800">
              <Link
                href="/login"
                className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary"
                onClick={() => setIsOpen(false)}
              >
                Log in
              </Link>
              <Link
                href="/sign-up"
                className="block px-3 py-2 rounded-md text-base font-medium text-white bg-primary hover:bg-primary/90 mt-1"
                onClick={() => setIsOpen(false)}
              >
                New User? Sign Up
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
